<template>
    <DModal
        :show="true"
        :title="title"
        @close="emit('closeModal')"
    >
        <div style="padding: 15px">
            <DFormRow
                :label="__('settings.sepa_retry_failure_codes.form.code')"
                is-required
                :hint="__('settings.sepa_retry_failure_codes.form.code_hint')"
            >
                <DInput
                    id="code"
                    v-model="form.code"
                    :invalid-feedback="form.errors.code"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.sepa_retry_failure_codes.form.description')"
                is-required
                :hint="__('settings.sepa_retry_failure_codes.form.description_hint')"
            >
                <DInput
                    id="description"
                    v-model="form.description"
                    :invalid-feedback="form.errors.description"
                />
            </DFormRow>
        </div>
        <template #actions>
            <DButton
                id="btn-cancel"
                color="secondary"
                :label="__('messages.cancel')"
                @click="emit('closeModal')"
            />
            <DButton
                id="btn-save"
                :label="__('messages.save')"
                :disabled="form.processing"
                @click="submitForm"
            />
        </template>
    </DModal>
</template>

<script setup>
import { computed } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    failureCode: {
        type: Object,
        default: () => null
    },
    isCreate: {
        type: Boolean,
        default: true
    }
})

const emit = defineEmits(['closeModal'])

const form = useForm({
    code: props.failureCode?.code ?? '',
    description: props.failureCode?.description ?? '',
})

const title = computed(() =>
    props.isCreate
        ? __('settings.sepa_retry_failure_codes.add_modal_title')
        : __('settings.sepa_retry_failure_codes.edit_modal_title')
)

function submitForm () {
    if (props.isCreate) {
        form.post(route('settings.sepa-retry-failure-codes.store'), {
            preserveScroll: true,
            onSuccess: () => emit('closeModal'),
        })
        return
    }

    form.patch(route('settings.sepa-retry-failure-codes.update', { sepaRetryFailureCode: props.failureCode.id }), {
        preserveScroll: true,
        onSuccess: () => emit('closeModal'),
    })
}
</script>
